import { useLocale } from 'state/intl';

import { supportRoute } from './routes';

export const useSupportLink = () => {
  const { language } = useLocale();
  return supportRoute[language];
};
